var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',[_c('InfoIcon',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n  You don't have access to reports on this profile.\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }